import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
const { wrapHOC } = FrameworkUtils;

import { userSelector } from 'selectors/user/userSelector';
import { saveForLaterListIdSelector, saveForLaterItemsSelector, saveForLaterLoadingSelector } from 'selectors/saveForLater/saveForLaterSelectors';
import SaveForLaterActions from 'actions/SaveForLaterActions';
import Actions from 'actions/Actions';
import SaveForLaterUtils from 'utils/SaveForLaterUtils';
import Empty from 'constants/empty';

const { prepareSaveForLaterCarouselData } = SaveForLaterUtils;

const fields = createSelector(
    userSelector,
    saveForLaterListIdSelector,
    saveForLaterItemsSelector,
    saveForLaterLoadingSelector,
    (user, saveForLaterListId, saveForLaterItems, saveForLaterLoading) => {
        const rawSaveForLaterItems = Array.isArray(saveForLaterItems) ? saveForLaterItems : Empty.Array;
        const saveForLaterCarouselData = prepareSaveForLaterCarouselData({
            isEnabled: true,
            items: rawSaveForLaterItems,
            listId: saveForLaterListId
        });

        return {
            saveForLaterCarouselData,
            saveForLaterLoading,
            userId: user?.userId || user?.profileId
        };
    }
);

const functions = {
    removeSavedForLater: SaveForLaterActions.removeItemFromSaveForLater,
    showSavedForLaterModal: Actions.showSavedForLaterModal,
    showChangeMethodModal: Actions.showChangeMethodModal,
    moveItemToBasket: SaveForLaterActions.moveItemToBasketFromSaveForLater
};

const withSavedForLaterCarouselProps = wrapHOC(connect(fields, functions));

export {
    withSavedForLaterCarouselProps, fields, functions
};
